<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-truck mr-2" />Barang Masuk - Kloter Pengiriman</h5>
            <hr />
            <b-row>
                <b-col md="2">
                    <b-form-group label="Tgl. Pengiriman Dari">
                        <b-form-input id="startDate-input" type="date" v-model="filter.startDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="2">
                    <b-form-group label="Tgl. Pengiriman Sampai">
                        <b-form-input id="endDate-input" type="date" v-model="filter.endDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button id="search-button" variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
                <b-col md="5" class="text-right">
                    <b-form-group label="Input Barang">
                        <div class="d-flex flex-nowrap justify-content-end">
                            <router-link to="/barang-masuk/input-emas" class="mr-2 text-decoration-none" v-if="isBarangMasukEmas">
                                <b-button id="process-item-button" class="d-flex align-items-center flex-nowrap"  variant="warning" @click="getItems()">
                                    <i class="fa fa-pencil mr-2" />Proses Barang Masuk (Emas)
                                </b-button>
                            </router-link>
                            <router-link to="/barang-masuk/input" class="text-decoration-none">
                                <b-button id="process-item-button" class="d-flex align-items-center flex-nowrap"  variant="dark" @click="getItems()">
                                    <i class="fa fa-pencil mr-2" />Proses Barang Masuk
                                </b-button>
                            </router-link>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
                id="items-table"
            >
                <template v-slot:empty>
                    Tidak ada data kloter pengiriman.
                </template>
                <template v-slot:cell(date)="row">
                    {{ $helper.parseDate(row.item.date) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-link :to="'/barang-masuk/' + row.item.id">
                        <b-button :id="`detail-button-${row.index}`" size="sm" variant="primary" v-b-tooltip.hover.top title="Detail">
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </b-link>
                </template>
            </b-table>
            <PageSizer id="page-sizer" :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
    </div>
</template>

<script>
import helper from '@/helper'
import EnumPermissions from '@/shared/enum-permissions'

export default {
    name: 'barang-masuk-list',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                startDate: "",
                endDate: ""
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "date", label: "Tanggal Pengiriman", sortable: true },
                { key: "total_batch", label: "Total Batch", sortable: true },
                { key: "total_item", label: "Total Barang", sortable: true },
                { key: "source", label: "Sumber", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {},
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            Promise.all([getItems]).then(() => {
                this.initStatus = 1
            })
            .catch(() => {
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if(!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("delivery/list" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listPengirimanFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        }

    },
    computed: {
        isBarangMasukEmas() {
            return helper.checkRoleNumber(EnumPermissions.APPROVE_GOLD.toString(), localStorage.getItem("permissions"))
            || helper.checkRoleNumber(EnumPermissions.CREATE_EXTERNAL_INVENTORY_GOLD.toString(), localStorage.getItem("permissions")) || localStorage.getItem("roleName").includes('Superadmin')
        }
    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listPengirimanFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listPengirimanFilter"))
        }
        this.init()
    }
}
</script>
